import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API, API_URL } from '../../../config/api';

const api_url = API_URL + API.GOVERNMENTS.ADDGOVERNMENT;

export const getGovernments = createAsyncThunk(
  'governments/getGovernments',
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const response = await axios.get(`${api_url}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const addGovernment = createAsyncThunk(
  'governments/addGovernment',
  async (governmentData, thunkAPI) => {
    try {
      const response = await axios.post(api_url, governmentData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteGovernment = createAsyncThunk(
  'governments/deleteGovernment',
  async (governmentId, thunkAPI) => {
    try {
      await axios.delete(`${api_url}/${governmentId}`);
      return governmentId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getGovernmentById = createAsyncThunk(
  'governments/getGovernmentById',
  async (governmentId, thunkAPI) => {
    try {
      const response = await axios.get(`${api_url}/${governmentId}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateGovernment = createAsyncThunk(
  'governments/updateGovernment',
  async ({ governmentId, governmentData }, thunkAPI) => {
    try {
      const response = await axios.patch(`${api_url}/${governmentId}`, governmentData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const filterGovernments = createAsyncThunk(
  'governments/filterGovernments',
  async (filterData, thunkAPI) => {
    try {
      const response = await axios.post(`${api_url}/filter`, filterData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
